//* 관리자용 장례식장 정보 관리 페이지
import { FC, useMemo, useState } from 'react';

import { useRecoilValue, useSetRecoilState } from 'recoil';

import { FuneralHomeInfo } from '@shared/api/funeralHomeInfo/funeralHomeInfo.interface';
import { FuneralHomeInfoListStateSelector } from '@shared/api/funeralHomeInfo/funeralHomeInfo.selector';
import { Button } from '@shared/components/Button';
import { Loading } from '@shared/components/Loading';
import { TextField } from '@shared/components/TextField';
import FuneralHomeInfoSearchList from '@shared/containers/FuneralHomeInfoSearcher/FuneralHomeInfoSearchList';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import FuzzySearch from 'fuzzy-search';
import { useNavigate } from 'react-router-dom';

import {
  ADMIN_FUNERAL_HOME_INFO_CREATE_MODAL_OPEN_ID,
  AdminFuneralHomeInfoCreateModal,
} from '../components/AdminFuneralHomeInfoCreateModal';
import { useAdminTitleHook } from '../hooks/useAdminTitleHook';

const AdminFuneralHomeInfoManagePage: FC = function AdminFuneralHomeInfoManagePage() {
  useAdminTitleHook('장례식장정보 관리');
  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const funeralHomeInfoListState = useRecoilValue(FuneralHomeInfoListStateSelector);
  const navigate = useNavigate();
  const setCreateOpen = useSetRecoilState(
    simpleOpenAtomFamily(ADMIN_FUNERAL_HOME_INFO_CREATE_MODAL_OPEN_ID),
  );
  const funeralHomeInfoListTable = useMemo(() => {
    if (funeralHomeInfoListState.status === 'success' && funeralHomeInfoListState.data) {
      const funeralHomeInfoList = funeralHomeInfoListState.data;

      const searcher = new FuzzySearch(funeralHomeInfoList, [
        'name',
        'address',
        'phoneNumber',
      ]);

      const searchedFuneralHomeInfoList = searcher.search(searchValue);
      const onItemClickInListStep = (item: FuneralHomeInfo<undefined, string>) => {
        navigate(`/admin/funeral-home-info/${item._id}/edit`);
      };
      return (
        <FuneralHomeInfoSearchList
          searchedFuneralHomeInfoList={searchedFuneralHomeInfoList}
          onItemClick={onItemClickInListStep}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          chunkSize={10}
        />
      );
    } else {
      return (
        <div className="center-box">
          <Loading />
        </div>
      );
    }
  }, [
    funeralHomeInfoListState.data,
    funeralHomeInfoListState.status,
    navigate,
    searchValue,
    selectedPage,
  ]);

  return (
    <div className="space-y-2 p-2">
      <div className="flex items-center justify-end">
        <Button
          onClick={() => setCreateOpen(true)}
          className="rounded-md px-3 py-1 text-14 theme-text-3 theme-bg-main"
        >
          신규 장례식장 생성
        </Button>
      </div>
      <TextField
        className="w-full"
        placeholder="장례식장 이름 및 지역을 검색하세요."
        onChange={(e) => {
          setSelectedPage(1);
          setSearchValue(e.target.value);
        }}
      />
      <div className="space-y-2 bg-gray-100">{funeralHomeInfoListTable}</div>
      <AdminFuneralHomeInfoCreateModal />
    </div>
  );
};

export default AdminFuneralHomeInfoManagePage;
